import {showFormResponse} from "../common/json-response";

let inputCompany, statusWrapper, suggestionsBlock;

function initCompanySuggestions() {
  inputCompany = document.querySelector('input#search_company');

  if (!inputCompany) {
    return;
  }

  statusWrapper = document.querySelector('.action-status-messages');
  suggestionsBlock = inputCompany.closest('.form__card').querySelector('.suggestions-wrapper');

  const getSuggestAddresHandler = function (e) {
    let url = e.target.getAttribute('data-url');
    url = url + '?value=' + inputCompany.value;
    const code = document.querySelector('[name="code"]');
    const email = document.querySelector('[name="email"]');

    if (code && email) {
      url = url + '&code=' + code.value + '&email=' + email.value;
    }

    $.ajax({
      type: "GET",
      url: url,
      dataType: 'json',
      success: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else if (data.html) {
          suggestionsBlock.innerHTML = '';
          suggestionsBlock.insertAdjacentHTML('beforeEnd', data.html);
          suggestionsBlock.classList.add('active');

          initSuggestions();
        }
      },
      error: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else {
          const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
          const statusMsg = document.createElement('div');
          statusMsg.classList.add(['alert']);
          statusMsg.classList.add(['alert_error']);
          statusMsg.innerHTML = message;
          statusWrapper.appendChild(statusMsg);
        }
      },
    });
  };

  inputCompany.addEventListener('input', getSuggestAddresHandler);
  initSuggestions();

  document.addEventListener('click', (e) => {
    if(e.target.closest('.suggestions-wrapper') !== suggestionsBlock){
      suggestionsBlock.classList.remove('active');
    }
  });
}

function initSuggestions() {
  if (!suggestionsBlock) {
    return;
  }

  const suggestions = suggestionsBlock.querySelectorAll('.suggestions-suggestion');

  suggestions?.forEach(function (item) {
    item.addEventListener('click', function (e) {
      const valueElement = item.querySelector('.suggestions-value');
      const name = valueElement.getAttribute('data-name');
      const nameInput = document.querySelector('input[name="company_name"]');
      nameInput.value = name;

      const companyInn = valueElement.getAttribute('data-company-inn');
      const companyInnInput = document.querySelector('input[name="company_tax_inn"]');
      companyInnInput.value = companyInn;

      const address = valueElement.getAttribute('data-address');
      const addressInput = document.querySelector('input[name="company_address"]');
      addressInput.value = address;

      suggestionsBlock.classList.remove('active');
    });
  });
}

export { initCompanySuggestions }